import {
  isValidIsoString,
  TimeQuestionConfig,
  TimeResponseState,
} from '@gripp/shared-logic';
import { useEffect, useRef } from 'react';
import { DatePickerSelector, useFormContext } from '../../../../../forms';
import {
  RoutineQuestionExecutionForm,
  RoutineQuestionExecutionFormProps,
} from '../../types';

export const TimeOnly: RoutineQuestionExecutionForm<
  TimeQuestionConfig,
  TimeResponseState
> = (
  props: RoutineQuestionExecutionFormProps<
    TimeQuestionConfig,
    TimeResponseState
  >
) => {
  const fieldPrefix = `responses.${props.responseIndex}.timeTypeValue`;
  const { control, setValue } = useFormContext();
  const keyRefresh = useRef<string>('timeOnly');
  const initialValue =
    props.currentState?.state?.responses?.[props.responseIndex]?.timeTypeValue;
  useEffect(() => {
    if (isValidIsoString(initialValue)) {
      setValue(fieldPrefix, initialValue, {
        shouldDirty: true,
        shouldValidate: true,
      });
      keyRefresh.current = 'timeOnly-refresh';
    }
  }, []);

  return (
    <DatePickerSelector
      key={keyRefresh.current}
      name={fieldPrefix}
      setValue={setValue}
      control={control}
      label={''}
      placeholder="00:00"
      height={40}
      containerStyle={{
        justifyContent: 'center',
        height: '100%',
        width: '100%',
        paddingVertical: 0,
      }}
      mode="time"
    />
  );
};
